import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';

import MainLayout from '../../layout/Main';
import useIframeMessage from '../../../hooks/useIframeMessage';

const FeatureIframe = ({ featureKey, title }) => {
  const { iframeUrl } = useIframeMessage(featureKey);

  return (
    <MainLayout containerProps={{ pb: 0, minHeight: '100vh' }}>
      {iframeUrl && (
        <Box
          as="iframe"
          src={iframeUrl}
          title={title}
          sandbox="allow-forms allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
          allow="clipboard-read; clipboard-write"
          sx={{
            width: '100%',
            height: 'calc(100vh - 64px)',
            border: 'none',
            flex: 1,
          }}
        />
      )}
    </MainLayout>
  );
};

FeatureIframe.propTypes = {
  featureKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default FeatureIframe;
